module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/suny/"},"frontmatter":{"title":"SUNY"}}}]}},"pathContext":{"tag":"SUNY"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-suny.json
// module id = 438
// module chunks = 171289089103386